/**
 * Hook to fetch workspace channels
 */

import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { Channel, ChannelTemplate, channelsApi } from "../api";

export const useChannels = (): UseQueryResult<Channel[], Error> => {
  return useQuery<Channel[], Error>({
    queryKey: ["ai-studio", "channels"],
    queryFn: () => channelsApi.list(),
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: 2
  });
};

export const useChannelTemplates = (): UseQueryResult<ChannelTemplate[], Error> => {
  return useQuery<ChannelTemplate[], Error>({
    queryKey: ["ai-studio", "channel-templates"],
    queryFn: () => channelsApi.listTemplates(),
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: 2
  });
};
